import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

/*!*******************************************************************************!
  !*** SECURITY API CONFIG                                         ***!
  \*******************************************************************************/

export const apiConfig = {
  // MANAGE USERS
  DetailUsers: BOM.baseUrl("users"),
  Users: BOM.baseUrl("users"),

  Audits: BOM.baseUrl("audits"),

  //MANAGE EMPLOYEES
  Staff: BOM.baseUrl("staff"),
  Offices: BOM.baseUrl("offices"),

  // MANAGE ROLES
  Roles: BOM.baseUrl("roles"),

  // PASSWORD PREFERENCES
  PasswordPreferences: BOM.baseUrl("passwordpreferences"),

  // TWO FACTOR CONFIG
  TwoFactor: BOM.baseUrl("twofactor"),

  // AUTHORIZATION
  Permissions: BOM.baseUrl("permissions"),

  // CHECKER INBOX AND TASKS
  MakerCheckers: BOM.baseUrl("makercheckers"),
  Search: BOM.baseUrl("search"),
  Loans: BOM.baseUrl("loans"),
  Batches: BOM.baseUrl("batches"),
  Rescheduleloans: BOM.baseUrl("rescheduleloans"),
  Clients: BOM.baseUrl("clients"),
};

//
/*!*******************************************************************************!
  !*** SECURITY LABEL CONFIG                                                       ***!
  \*******************************************************************************/
export const labelConfig = {
  manageEmployees: "Manage Employees",
  employees: "Employees",
  employee: "Employee",
  createEmployees: "Create Employee",
  newEmployee: "New Employee",
  editEmployee: "Edit Employee",
  office: "Office",
  branch: "Branch",
  firstName: "First Name",
  lastName: "Last Name",
  isLoanOfficer: "Is Loan Officer?",
  mobileNumberforSMS: "Mobile Number for SMS",
  joinedOn: "Joined On",
  active: "Active",
  detailEmployee: "Employee Details",
  managePasswordPreferences: "Manage Password Preferences",
  simple: "Password must be at least 1 character and not more than 50 characters long",
  secure:
    "Password must be at least 6 characters, no more than 50 characters long, must include at least one upper case letter, one lower case letter, one numeric digit and no space",
  passwordPreferenceMsg: "Password Preference is Successfully Set",
  option: "Option",

  //SUCCESS MESSAGES
  newEmployeeMsg: "New Employee was successfully created",
  editEmployeeMsg: "Employee was successfully edited",

  //   AUDIT TRAILS
  manageAuditTrail: "Manage Audit Trails",
  auditTrail: "Audit Trails",
  detailAuditTrails: "View Audit Entry",
  id: "ID",
  resourceId: "Resource ID",
  status: "Status",
  madeBy: "Made By",
  action: "Action",
  entity: "Entity ",
  branch: "Branch",
  madeDate: "Made Date",
  userIp: "User IP",
  timeStamp: "Timestamp",
  checker: "Checker",
  checkedDate: " Checked Date",
  checkedDateTimeStamp: "Checked Timestamp",
  madeDateTimeStamp: "Made Timestamp",
  searchAuditTrail: "Search Audit Trails",
  customer: "Customer",
  fromDate: "From Date",
  checkedTo: "Checked To",
  checkedFrom: "Checked From",
  toDate: "To Date",
  searchByUser: "Search By User (maker)",
  checkedStartPeriod: "Checked Start Period",
  checkedEndPeriod: "Checked End Period",
  maker: "Maker",

  // PASSWORD
  changePassword: "Reset Password",
  repeatPassword: "Repeat Password",
  password: "Password",
  userName: "Username",
  email: "Email",
  staff: "Staff",
  accountOfficer: "Account Officer",
  changePasswordMsg: "Password Changed Successfully",
  unblockUserMsg: "User Unblocked Successfully",
  unblockUser: "Unblock User",
  blockUserMsg: "User Blocked Successfully",

  manageRoles: "Manage Roles",
  roles: "Roles",
  name: "Name",
  newRole: "New Role",
  detailUser: "Detail User",
  editUser: "Edit User",
  newRoleMsg: "New Role is Created Successfully",
  description: "Description",
  deleteUserMsg: "User Deleted Successfully",
  detailRole: "Detail Role",
  editRole: "Edit Role",
  deleteRoleMsg: "Role is Successfully Deleted",

  // MANAGE USERS
  manageUsers: "Manage Users",
  newUser: "New User",
  manageUsersDetail: "User Details",
  editUsersDetail: "Edit User",
  EditManageUsersMsg: "User was successfully updated",
  editManageUsersBreadcrumbs: "Edit User",
  manageUsersAutoGeneratePassword: "Auto Generate Password",
  manageUsersOverridePassword: "Override Password Expiry Policy?",
  manageUsersOffice: "Office",
  manageUsersRoles: "Roles",
  manageUsersStaff: "Staff",
  manageUsersAccessDays: "Access Days",
  manageUsersAccessTime: "Access Time",
  manageUsersAllowAccess: "Allow Access On",
  manageUsersStartTime: "Start Time",
  manageUsersStartDate: "Start Date",
  manageUsersEndTime: "End Time",
  manageUsersEndDate: "End Date",
  manageUsersTimezone: "Timezone",
  manageUsersTemporaryUser: "Set as a temporary user",
  newUserMsg: "New User was successfully created",
  enableUserMsg: "User was successfully enabled",
  disableUserMsg: "User was successfully disabled",
  confirmPassword: "Confirm Password",
  listOfUsers: "List of Users",
  enableRoleMsg: "Role is Enabled Successfully",
  disableRoleMsg: "Role is Disabled Successfully",

  // TWO FACTOR CONFIG
  detailTwoFactorConfig: "View Two-Factor Configuration",
  value: "Value",
  edit: "Edit",
  otpDeliverySmsEnable: "otp-delivery-sms-enable",
  otpDeliverySmsProvider: "otp-delivery-sms-provider",
  otpDeliverySmsText: "otp-delivery-sms-text",
  otpDeliveryEmailEnable: "otp-delivery-email-enable",
  otpDeliveryEmailSubject: "otp-delivery-email-subject",
  otpDeliveryEmailBody: "otp-delivery-email-body",
  otpTokenLength: "otp-token-length",
  accessTokenLiveTimeExtended: "access-token-live-time-extended",
  otpTokenLiveTime: "otp-token-live-time",
  accessTokenLiveTime: "access-token-live-time",
  updateSMSMsg: "SMS configuration was successfully updated",
  updateEmailMsg: "Email configuration was successfully updated",
  updateTokenMsg: "Token configuration was successfully updated",
  authorization: "Authorization",
  makerCheckerTasks: "Maker Checker Tasks",
  id: "ID",
  madeOnDate: "Made on Date",
  user: "User",
  entity: "Entity",
  manageCheckerInbox: "Manage Checker Inbox",
  manageCheckerInboxList: "Manage Checker Inbox List",
  detailCheckerInbox: "Detail Checker Inbox",
  date: "Date",
  approveCheckerMsg: "Checker Approved Successfully",
  rejectCheckerMsg: "Checker Rejected Successfully",
  deleteCheckerMsg: "Checker Deleted Successfully",
  // CHECKER INBOX AND TASKS
  manageLoanApproval: "Manage Loan Approval",
  detailLoanApproval: "Loan Approval Detail",
  loanPurpose: "Loan Purpose",
  loan: "Loan",
  amount: "Amount",
  manageLoanDisbursal: "Manage Loan Disbursal",
  detailLoanDisbursal: "Loan Disbursal Detail",
  loanAccountNumber: "Loan account number",
  loanProduct: "Loan Product",
  principal: "Principal",
  manageRescheduleLoan: "Manage Reschedule",
  rescheduleRequest: "Reschedule Request#",
  rescheduleFrom: "	Reschedule From",
  rescheduleReason: "Reschedule Reason",
  searchCheckerInbox: "Search Checker Inbox",
  manageClientApproval: "Manage Client Approval",
  clientApproval: "Client Approval",
  clientNumber: "Client Number",
  activationDate: "Activation Date",
  firstname: "First Name",
  lastname: "Last Name",
  clientStatus: "Client Status",
  myProfile: "My Profile",
  dashboard: "Dashboard",
};

/*!*******************************************************************************!
    !*** SECURITY STATIC CONFIG                                                      ***!
    \*******************************************************************************/
export const staticConfig = {
  // MANAGE USERS ITEMS
  manageUsersItems: [{ title: labelConfig.manageUsers }],
  newUserBreadcrumbItems: [
    { title: <Link to="/sms0100">{labelConfig.manageUsers}</Link> },
    { title: labelConfig.newUser },
  ],
  detailManageUsersItems: [
    { title: <Link to="/sms0100">{labelConfig.manageUsers}</Link> },
    { title: labelConfig.detailUser },
  ],
  editUsersBreadcrumbItems: [
    { title: <Link to="/sms0100">{labelConfig.manageUsers}</Link> },
    { title: labelConfig.editUser },
  ],

  manageEmployeesBreadcrumbItems: [{ title: labelConfig.manageEmployees }],

  statusData: [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
  ],
  yesOrNoData: [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ],
  filterByEntries: [
    { label: "All", value: "All" },
    { label: "Manual Entries", value: "Manual Entries" },
    { label: "System Entries", value: "System Entries" },
  ],
  yesOrNo: [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ],
  activateCustomerGroupBreadcrumbItems: [
    // { title: <Link to="/manage-group">{labelConfig.manageGroup}</Link> },
    { title: labelConfig.activateCustomerGroup },
  ],
  newEmployeeBreadcrumbItems: [
    { title: <Link to="/sms0200">{labelConfig.manageEmployees}</Link> },
    { title: labelConfig.newEmployee },
  ],
  editEmployeesBreadcrumbItems: [
    { title: <Link to="/sms0200">{labelConfig.manageEmployees}</Link> },
    { title: labelConfig.editEmployee },
  ],
  detailEmployeesBreadcrumbItems: [
    { title: <Link to="/sms0200">{labelConfig.manageEmployees}</Link> },
    { title: labelConfig.detailEmployee },
  ],

  passwordPreferencesBreadcrumbItems: [{ title: labelConfig.managePasswordPreferences }],

  manageAuditTrailBreadcrumbItems: [{ title: labelConfig.auditTrail }],

  searchAuditTrailBreadcrumbItems: [
    { title: <Link to="/sms0500">{labelConfig.manageAuditTrail}</Link> },
    { title: labelConfig.searchAuditTrail },
  ],

  detailAuditTrailBreadcrumbItems: [
    { title: <Link to="/sms0500">{labelConfig.manageAuditTrail}</Link> },
    { title: labelConfig.detailAuditTrails },
  ],

  detailManageUsersItems: [
    { title: <Link to="/sms0100">{labelConfig.manageUsers}</Link> },
    { title: labelConfig.manageUsersDetail },
  ],
  manageRolesBreadcrumbItems: [{ title: labelConfig.manageRoles }],

  newRoleBreadcrumbItems: [
    { title: <Link to="/sms0400">{labelConfig.manageRoles}</Link> },
    { title: labelConfig.newRole },
  ],

  detailRoleBreadrumbItems: [
    { title: <Link to="/sms0400">{labelConfig.manageRoles}</Link> },
    { title: labelConfig.detailRole },
  ],

  authorizationBreadrumbItems: [{ title: labelConfig.authorization }],

  editRoleBreadrumbItems: [
    { title: <Link to="/sms0400">{labelConfig.manageRoles}</Link> },
    { title: labelConfig.editRole },
  ],
  detailTwoFactorConfigBreadrumbItems: [
    // { title: <Link to="/sms0400">{labelConfig.manageRoles}</Link> },
    { title: labelConfig.detailTwoFactorConfig },
  ],
  trueOrFalseData: [
    { label: "True", value: true },
    { label: "False", value: false },
  ],

  manageCheckerInboxBreadcrumbItems: [{ title: labelConfig.manageCheckerInbox }],

  detailCheckerInboxBreadcrumbItems: [
    { title: <Link to="/sms0800">{labelConfig.manageCheckerInbox}</Link> },
    { title: labelConfig.detailCheckerInbox },
  ],

  manageLoanApprovalBreadcrumbItems: [{ title: labelConfig.manageLoanApproval }],
  manageLoanDisbursalBreadcrumbItems: [{ title: labelConfig.manageLoanDisbursal }],
  manageRescheduleLoanBreadcrumbItems: [{ title: labelConfig.manageRescheduleLoan }],

  searchCheckerInboxBreadcrumbItems: [
    { title: <Link to="/sms0800">{labelConfig.manageCheckerInbox}</Link> },
    { title: labelConfig.searchCheckerInbox },
  ],

  manageClientApprovalBreadcrumbItems: [{ title: labelConfig.manageClientApproval }],
  profileBreadcrumbItems: [
    { title: <Link to="/dashboard">{labelConfig.dashboard}</Link> },
    { title: labelConfig.myProfile },
  ],

  statusLabels: [
    { label: "All Status", value: "All" },
    { label: "Enabled", value: "Enabled" },
    { label: "Disabled", value: "Disabled" },
  ],
};
